"use client"

import dynamic from "next/dynamic"
import { ComponentType } from "react"
import type { MarketRate } from "@/app/components/atomic/organisms/TempsTravailCredit"

interface TempsTravailCreditProps {
    marketRate?: MarketRate
}

// Code-split so guide pages without the tool never ship it, but server-rendered so its copy stays crawlable
const TempsTravailCredit = dynamic(
    () =>
        import("@/app/components/atomic/organisms/TempsTravailCredit") as Promise<{
            default: ComponentType<TempsTravailCreditProps>
        }>,
)

export default TempsTravailCredit
